import React from "react";

const Bg = () => {
    return (
        <div className='c_bg'>
            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bg.jpg" />
        </div>
    );
};

export default Bg;